import React from "react";
import { Select, Typography } from "antd";

const { Text } = Typography;

const CategorySubCategoryFilters = ({
    selectedCategory,
    selectedSubCategory,
    categoryOptions,
    subCategoryOptions,
    onCategoryChange,
    onSubCategoryChange
}) => {
    return (
        <div className="content-filter-panel">
            <Text className="content-filter-panel__label">Category</Text>
            <Select
                allowClear
                placeholder="Select Category"
                value={selectedCategory}
                options={categoryOptions}
                onChange={onCategoryChange}
                className="content-filter-panel__select"
            />
            {subCategoryOptions.length > 0 ? (
                <>
                    <Text className="content-filter-panel__label">Sub Category</Text>
                    <Select
                        allowClear
                        placeholder="Select Sub Category"
                        value={selectedSubCategory}
                        options={subCategoryOptions}
                        onChange={onSubCategoryChange}
                        className="content-filter-panel__select"
                    />
                </>
            ) : null}
        </div>
    );
};

export default CategorySubCategoryFilters;
